import { ColorProps, FlexboxProps, LayoutProps } from "styled-system";
import { FieldProps, getIn } from "formik";
import React, { InputHTMLAttributes } from "react";
import { InputTextProps } from "../InputText/InputText";
import { DatePicker } from "../DatePicker";
import moment from "moment";

interface Props {
  isDayEnabled: (date: Date) => boolean;
  displayDateFormat: string;
  openToDate?: Date;
}

const formikDateFormat = "YYYY-MM-DD";

export const FormikDatePicker: React.FC<
  Props &
    FieldProps &
    FlexboxProps &
    InputTextProps &
    ColorProps &
    LayoutProps &
    InputHTMLAttributes<HTMLInputElement>
> = ({
  field,
  form,
  isDayEnabled,
  displayDateFormat,
  openToDate,
  value,
  ...props
}) => {
  const error = getIn(form.errors, field.name);
  const touch = getIn(form.touched, field.name);

  const selectedDate =
    typeof value === "string" && value
      ? moment(value, formikDateFormat).toDate()
      : undefined;

  const displayValue =
    typeof value === "string" && value
      ? moment(value, formikDateFormat).format(displayDateFormat)
      : undefined;

  const handleOnChange = (date: Date | null) => {
    form.setFieldValue(field.name, moment(date).format(formikDateFormat), true);
  };

  const handleOnBlur = () => {
    form.setFieldTouched(field.name, true);
  };

  return (
    <DatePicker
      {...field}
      onChangeDate={handleOnChange}
      isDayEnabled={isDayEnabled}
      selectedDate={selectedDate}
      displayValue={displayValue}
      error={touch && error ? error : false}
      onBlur={handleOnBlur}
      openOnDate={openToDate}
      {...props}
    />
  );
};
